// VHWWEB-136 — clicking into the course search field or the filter bar brings
// the search mask + filter bar up to the top of the viewport ("focus mode", per
// Klickdummy), so the results and filter panels get the maximum vertical space.
//
// Delegated on `document` so it survives the AJAX filter swaps that replace the
// search-filter section. Bound to `click` (not `focus`): a programmatic
// `.focus()` — e.g. CourseFilterLive's post-swap focus restoration, which is
// deliberately scroll-free — never fires a click, so this cannot reintroduce
// the unwanted post-swap jump.
const TRIGGER_SELECTOR = '[data-js="search-form-input"], [data-js="search-filter-bar"]'
const CONTAINER_SELECTOR = '[data-js="search-page-header"]'

class CourseSearchScroll {
  public init(): void {
    document.addEventListener('click', (event: MouseEvent): void => {
      const target = event.target as HTMLElement | null
      const trigger = target?.closest(TRIGGER_SELECTOR)
      if (!trigger) return

      const header = trigger.closest<HTMLElement>(CONTAINER_SELECTOR)
      if (!header) return

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      header.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' })
    })
  }
}

const courseSearchScroll = new CourseSearchScroll()
courseSearchScroll.init()
